import { ROLE } from '../../../lib/constants';
import { ReportStatus } from '../../ReportEdit/TitleArea';

/**
 * 報告書の各種権限を返却する関数
 *
 * @param {string} role - ユーザのロール
 * @param {object} userInfo - ユーザ情報
 * @param {array} groups - ユーザ所属グループ
 * @param {object} report - 対象の報告書
 * @returns {object} accessible - 権限オブジェクト
 */

const accessible = (role, userInfo, groups, report) => {
  // 自身で作成した報告書か
  const isSelf = userInfo.operatorId === report.createdOperatorId;
  // 下書きは自分の報告書のみ各種操作可能
  if (report.status === ReportStatus.create) {
    return { read: isSelf, edit: isSelf, delete: isSelf };
  }

  // 対象報告書が共有ステータスである
  const isStatusPublished = report.status === ReportStatus.published;

  switch (role) {
    case ROLE.COMPANY_ADMIN:
      return {
        read: true,
        edit: isStatusPublished,
        delete: true,
      };
    case ROLE.ADMIN:
      return {
        read: true,
        edit: isStatusPublished,
        delete: true,
      };
    case ROLE.GENERAL: {
      const igGroupMember = groups.some(({ id }) => report.groupId === id);
      return {
        read: igGroupMember,
        edit: isStatusPublished && igGroupMember,
        delete: (role === ROLE.Admin && igGroupMember) || isSelf,
      };
    }
    case ROLE.GUEST:
      // ゲストは自身のみアクセス可能
      return {
        read: isSelf,
        edit: isStatusPublished && isSelf,
        delete: isStatusPublished && isSelf,
      };
    default:
      return { read: false, edit: false, delete: false };
  }
};

export default accessible;
